import React from 'react';
import { Card, Typography, Box } from '@mui/material';
import { IconStethoscope } from '@tabler/icons-react';
import { styled } from '@mui/material/styles';
import dayjs from 'dayjs';

const StyledIcon = styled(IconStethoscope)(() => ({
    width: '100px',
    height: '100px'
}));

const ConsultationCard = ({ appointment, onClick }) => {
    const formattedDate = dayjs(appointment.ts).format('DD/MM/YYYY - HH:mm');
    const indication = appointment.summary ?? '—';

    return (
        <div
            role="button"
            tabIndex={0}
            onClick={onClick}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') onClick();
            }}
            style={{ cursor: 'pointer' }}
        >
            <Card
                elevation={0}
                sx={{
                    display: 'flex',
                    backgroundColor: '#ffffff',
                    boxShadow: 'none',
                    border: '2px solid #0A579B',
                    transition: '0.2s ease-in-out',
                    '&:hover': {
                        boxShadow: 6,
                        transform: 'scale(1.02)'
                    }
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '20px'
                    }}
                >
                    <StyledIcon sx={{ color: '#0A579B' }} />
                </Box>

                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-around',
                        padding: '10px'
                    }}
                >
                    <Typography variant="h2" sx={{ color: '#0A579B' }}>
                        Consulta
                    </Typography>

                    <Typography variant="h5">{formattedDate}</Typography>
                    <Typography variant="h5">Indicação: {indication}</Typography>
                </Box>
            </Card>
        </div>
    );
};

export default ConsultationCard;
